module.exports = __webpack_public_path__ + "static/media/Location Mark.F02.2k.eabb76bc.png";